module.exports = __webpack_public_path__ + "img/goyoga-manager-blog-team.60d8a57.jpeg";